module.exports = __webpack_public_path__ + "static/img/tel-bnr.007f1f3.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tel-bnr.jpeg
// module id = ATFq
// module chunks = 0